import { Phone, Mail, Instagram } from "lucide-react";
import { Reveal } from "./Reveal";

export const Contact = () => (
  <section id="contact" className="border-t border-slate-200 bg-slate-50/75" data-testid="contact-section">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:py-24 lg:px-10 lg:py-36">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-blaze">Contact</p>
        <h2 className="font-display text-5xl font-semibold uppercase leading-[0.9] tracking-tighter sm:text-6xl lg:text-8xl">
          Ready to<br /><span className="text-blaze">move?</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px border border-line bg-line sm:grid-cols-3">
        {[
          { icon: Phone, label: "Call us today", value: "03 9113 6005", href: "tel:0391136005", testid: "contact-phone" },
          { icon: Mail, label: "Email", value: "info@moversnearby.com.au", href: "mailto:info@moversnearby.com.au", testid: "contact-email" },
          { icon: Instagram, label: "Follow us", value: "@moversnearby", href: "https://instagram.com/moversnearby", testid: "contact-instagram" },
        ].map((c) => (
          <a
            key={c.label}
            href={c.href}
            target={c.href.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={c.testid}
            className="group flex flex-col gap-6 bg-coal p-8 transition-colors duration-500 hover:bg-slate-100/70 lg:p-10"
          >
            <c.icon className="h-7 w-7 text-blaze transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={1.8} />
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-slate-500">{c.label}</p>
              <p className="mt-2 font-display text-lg font-semibold tracking-tight text-slate-900 transition-colors group-hover:text-blaze lg:text-xl">
                {c.value}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
